module.exports = __webpack_public_path__ + "card.6802b801.png";


//////////////////
// WEBPACK FOOTER
// ./src/db/img/card.png
// module id = Lnea
// module chunks = 1